import React, { useEffect, useRef, useState } from "react";
import { sanitizeHtml } from "../../utils/sanitizeHtml.js";

function HtmlNote({ html }) {
  const contentRef = useRef(null);
  const [copyMessage, setCopyMessage] = useState("");

  useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement) return undefined;

    const copyElements = contentElement.querySelectorAll("[data-copy-code]");
    copyElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("tabindex", "0");
      element.setAttribute("title", "Nhấn để sao chép");
    });

    const copyCode = async (element) => {
      const content = (element.textContent || "").replace(/\s+/g, "");

      try {
        await navigator.clipboard.writeText(content);
        setCopyMessage(`Đã sao chép: ${content}`);
      } catch (error) {
        setCopyMessage("Không thể sao chép nội dung.");
      }
    };

    const handleClick = (event) => {
      const copyElement = event.target.closest("[data-copy-code]");
      if (copyElement && contentElement.contains(copyElement)) {
        copyCode(copyElement);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      const copyElement = event.target.closest("[data-copy-code]");
      if (copyElement && contentElement.contains(copyElement)) {
        event.preventDefault();
        copyCode(copyElement);
      }
    };

    contentElement.addEventListener("click", handleClick);
    contentElement.addEventListener("keydown", handleKeyDown);

    return () => {
      contentElement.removeEventListener("click", handleClick);
      contentElement.removeEventListener("keydown", handleKeyDown);
    };
  }, [html]);

  return (
    <>
      <div
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      />
      {copyMessage && (
        <p className="request-note-copy-message" role="status">
          {copyMessage}
        </p>
      )}
    </>
  );
}

export default HtmlNote;
